export enum SearchParamsVersion {
  v2 = '2',
}

export const currentSearchParamsVersion = SearchParamsVersion.v2;
